import UploadedFileViewDelete from './UploadedFileViewDelete';

export default UploadedFileViewDelete;
